import { PARTNERCOMMISSION__MUTATIONS } from "../mutation-types";
import { PARTNERCOMMISSION__ACTIONS } from "../action-types";
import { PARTNERCOMMISSION__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  totalCommission: 0,
  totalWithdrawal: 0,
  totalTransfer: 0,
  ibCommissionStatistics: [],
  withdrawalStatistics: [],
  transferlStatistics: [],
  isLoading: false,
};

// Mutations
const mutations = {
  [PARTNERCOMMISSION__MUTATIONS.PARTNERCOMMISSIONSTATISTICS](state, data) {
    state.ibCommissionStatistics = data?.modifiedData;
    state.totalCommission = data?.totalCommission;
  },

  [PARTNERCOMMISSION__MUTATIONS.PARTNERCOMMISSIONWITHDRAWAL](state, data) {
    state.withdrawalStatistics = data?.withdrawals;
    state.totalWithdrawal = data?.totalWithdrawal;
  },

  [PARTNERCOMMISSION__MUTATIONS.PARTNERTRANSFER](state, data) {
    state.transferlStatistics = data?.allTransfers;
    state.totalTransfer = data?.totalTransfer;
  },
  SET_LOADING(state, loadingState) {
    state.isLoading = loadingState;
  },
};

const getters = {};

// Actions
const actions = {
  async [PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONSTATISTICS](
    { commit },
    parameter
  ) {
    try {
      commit("SET_LOADING", true);

      const levelParam =
        !isNaN(parameter?.level) && typeof parameter?.level === "number"
          ? `level=${parameter.level}`
          : "";

      const accountTypeParam =
        parameter?.account_type != null
          ? `account_type=${parameter.account_type}`
          : "";

      const durationParam =
        parameter?.duration != null ? `duration=${parameter.duration}` : "";

      const parameterString = [levelParam, accountTypeParam, durationParam]
        .filter((param) => param !== "")
        .join("&");

      const { data } = await http().get(
        PARTNERCOMMISSION__API.PARTNERCOMMISSIONSTATISTICS +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      commit(
        PARTNERCOMMISSION__MUTATIONS.PARTNERCOMMISSIONSTATISTICS,
        data.data
      );
    } catch (error) {
      console.error("Error fetching partner commission statistics:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONWITHDRAWAL](
    { commit },
    parameter
  ) {
    try {
      commit("SET_LOADING", true);

      const paymentMethodParam =
        parameter?.payment_method != null
          ? `payment_method=${parameter.payment_method}`
          : "";
      const durationParam =
        parameter?.duration != null ? `duration=${parameter.duration}` : "";

      const parameterString = [paymentMethodParam, durationParam]
        .filter((param) => param !== "")
        .join("&");

      const { data } = await http().get(
        PARTNERCOMMISSION__API.PARTNERCOMMISSIONWITHDRAWAL +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      commit(
        PARTNERCOMMISSION__MUTATIONS.PARTNERCOMMISSIONWITHDRAWAL,
        data.data
      );
    } catch (error) {
      console.error("Error fetching partner commission withdrawal:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [PARTNERCOMMISSION__ACTIONS.PARTNERTRANSFER]({ commit }, parameter) {
    try {
      commit("SET_LOADING", true);

      const queryParams = parameter?.duration
        ? `?duration=${parameter.duration}`
        : "";

      const { data } = await http().get(
        PARTNERCOMMISSION__API.PARTNERTRANSFER + queryParams
      );

      commit(PARTNERCOMMISSION__MUTATIONS.PARTNERTRANSFER, data.data);
    } catch (error) {
      console.error("Error fetching partner transfers:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  }
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
